import { ApolloClient, NormalizedCacheObject, useLazyQuery } from '@apollo/client';
import { GetModuleData, GetModuleVars } from '../gql-types';

import GraphQL from '../gql';

let dashboardApolloClient: ApolloClient<NormalizedCacheObject> = null;

export function useLesson() {
  const [
    _getModule,
    { loading: loadingModule, error: loadModuleError, data: moduleData }
  ] = useLazyQuery<GetModuleData, GetModuleVars>(GraphQL.Query.GET_MODULE, {
    client: dashboardApolloClient,
    fetchPolicy: 'no-cache'
  });

  const getModule = async (modulekey: number) => {
    _getModule({
      variables: {
        modulekey
      }
    });
  };

  return {
    getModule,
    loadingModule,
    moduleData: moduleData?.getModule
  };
}
